import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/layout/Navigation";
import { Footer } from "./components/layout/Footer";
import { Home } from "./pages/Home";
import { CaseStudy } from "./pages/CaseStudy";
import { PageEffects } from "./components/layout/PageEffects";
import { ScrollControls } from "./components/layout/ScrollControls";
import { PointerGlow } from "./components/common/PointerGlow";
import "@fontsource/instrument-sans/latin-400.css";
import "@fontsource/instrument-sans/latin-500.css";
import "@fontsource/instrument-sans/latin-600.css";
import "@fontsource/instrument-serif/latin-400-italic.css";
import "./styles/index.css";
export default function App() {
  return (
    <BrowserRouter>
      <PageEffects />
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <div id="top" />
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work/:slug" element={<CaseStudy />} />
        <Route path="*" element={<CaseStudy />} />
      </Routes>
      <Footer />
      <ScrollControls />
      <PointerGlow />
    </BrowserRouter>
  );
}
